const carouselData = [
  {
    title: '某男团成员被爆私下恋情',
    excerpt: '据知情人士透露，某当红男团主唱与圈外女友已交往两年，多次被目击同行外出',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20pop%20culture%20and%20entertainment%20drama%20visual%20with%20warm%20coral%20pink%20and%20amber%20gradients%2C%20bold%20geometric%20shapes%2C%20magazine%20editorial%20style%2C%20dramatic%20lighting%20effect%2C%20clean%20minimal%20modern%20composition&width=600&height=400&seq=carousel-card-01&orientation=landscape',
    tag: '独家爆料',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '综艺节目暗箱操作内幕',
    excerpt: '前工作人员曝光某热门综艺暗箱操作细节，选手排名早已内定，观众投票形同虚设',
    img: 'https://readdy.ai/api/search-image?query=Bold%20abstract%20television%20studio%20concept%20with%20dramatic%20spotlight%20and%20shadow%20play%2C%20warm%20coral%20and%20deep%20orange%20color%20palette%2C%20geometric%20shapes%2C%20editorial%20graphic%20design%20style%2C%20modern%20minimalist%20composition&width=600&height=400&seq=carousel-card-02&orientation=landscape',
    tag: '深度扒皮',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '网红直播带货数据造假',
    excerpt: '第三方监测数据显示多名头部网红直播数据严重注水，实际成交不足展示数据的十分之一',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20digital%20data%20and%20social%20media%20influence%2C%20warm%20peach%20and%20coral%20gradients%2C%20floating%20numbers%20and%20graph%20motifs%2C%20modern%20editorial%20design%2C%20clean%20geometric%20composition&width=600&height=400&seq=carousel-card-03&orientation=landscape',
    tag: '数据打假',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '某女星与经纪公司解约风波',
    excerpt: '知名女演员因片酬分成问题与经纪公司对簿公堂，双方各执一词引发行业关注',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20legal%20and%20contract%20concept%20with%20warm%20amber%20and%20soft%20orange%20tones%2C%20document%20and%20pen%20motifs%20in%20geometric%20style%2C%20dramatic%20lighting%2C%20editorial%20magazine%20aesthetic&width=600&height=400&seq=carousel-card-04&orientation=landscape',
    tag: '行业热点',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '热门CP营业真相大揭秘',
    excerpt: '圈内人士爆料多数荧幕CP纯属营销炒作，真实关系与镜头前大相径庭',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20romantic%20drama%20visual%20with%20warm%20rose%20and%20coral%20gradients%2C%20split%20composition%20showing%20contrast%2C%20modern%20graphic%20design%20style%2C%20clean%20geometric%20shapes&width=600&height=400&seq=carousel-card-05&orientation=landscape',
    tag: '幕后真相',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '年度十大翻车事件回顾',
    excerpt: '盘点本年度娱乐圈最令人瞠目结舌的十大翻车事件，每一件都堪称经典',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20countdown%20and%20ranking%20visual%20concept%20with%20warm%20orange%20and%20amber%20gradients%2C%20numbered%20geometric%20elements%2C%20dramatic%20editorial%20style%2C%20bold%20typographic%20motifs&width=600&height=400&seq=carousel-card-06&orientation=landscape',
    tag: '年度盘点',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-focus-2-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">深度追踪当前最受关注的吃瓜事件，全面呈现事件来龙去脉</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group block"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { const el = e.currentTarget.parentElement; if (el) el.style.display = 'none'; }}
                />
              </div>
              <div className="p-5">
                <span className={`inline-block text-[10px] font-bold px-2 py-0.5 rounded mb-2 ${item.tagColor}`}>{item.tag}</span>
                <h3 className="font-heading font-bold text-foreground-900 text-base mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.excerpt}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}